import MailLink from "./mail-link";
export default MailLink;